import React from "react";
import { AnimatePresence, delay, motion } from "framer-motion";
import { Link, NavLink } from "react-router-dom";
import Image from "../components/elements/Image";
import Logo from "../assets/images/front/logo.png";
import Footerbg from "../assets/images/front/footerbg.webp"
import Input from "../components/form/front/Input";
import Button from "../components/form/front/Button";
const FrontFooter = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      delay: 0.5,
      transition: {
        duration: 0.4,
        ease: "easeOut",
        staggerChildren: 0.25,
        delayChildren: 0.1,
      },
    },
  };

  const columnVariants = {
    hidden: { opacity: 0, y: 50 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
    exit: { opacity: 0, y: -50, transition: { duration: 0.3 } },
  };

  const optionVariantsLeft = {
    hidden: { opacity: 0, x: -50 },
    show: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
    exit: { opacity: 0, x: -50, transition: { duration: 0.3 } },
  };

  const optionVariantsRight = {
    hidden: { opacity: 0, x: 50 },
    show: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
    exit: { opacity: 0, x: -50, transition: { duration: 0.3 } },
  };

  const sitemenudata = [
    { link: "/", name: "Find Job" },
    { link: "/review", name: "Company Review" },
  ];

  const helpmenudata = [
    { link: "/about", name: "About" },
    { link: "/terms", name: "Terms of use" },
    { link: "/privacy-policy", name: "Privacy Policy" },
  ];

  const socialmediadata = [
    {
      id: 1,
      name: "Facebook",
      link: "https://facebook.com/yourpage",
      icon: "fa-facebook-f",
    },
    {
      id: 2,
      name: "LinkedIn",
      link: "https://linkedin.com/company/yourcompany",
      icon: "fa-linkedin-in",
    },
    {
      id: 3,
      name: "Instagram",
      link: "https://instagram.com/yourprofile",
      icon: "fa-instagram",
    },
    {
      id: 4,
      name: "Twitter",
      link: "https://x.com/",
      icon: "fa-x-twitter",
    },
  ];

  return (
    <>
      <footer className="relative py-10 md:py-12 xls:py-16 overflow-hidden">
        <div className="absolute left-0 top-0 w-full h-full">
            <Image src={Footerbg} classes={"object-cover"}/>
        </div>
        <div className="relative w-full px-4 sm:px-0 max-w-full md:max-w-3xl lg:max-w-4xl xls:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto">
          <div className="relative">
            <motion.div
              key="front-footer-content"
              variants={containerVariants}
              initial="hidden"
              whileInView="show"
              exit="hidden"
              viewport={{ once: true, amount: 0.3 }}
              className="grid grid-cols-12 gap-4 py-12"
            >
              <motion.div
                key="front-footer-content-1"
                variants={columnVariants}
                className="col-span-12 xls:col-span-5 space-y-4 md:space-y-8 pr-0 md:pr-20 2xl:pr-28"
              >
                <div className="relative h-9 md:h-11 flex overflow-hidden">
                  <Link to={"/"} className="block w-full h-full overflow-hidden">
                    <Image src={Logo} alt={""} effect={"blur"} classes={"object-contain object-left"}/>
                  </Link>
                </div>
                <div className="text-white text-base md:text-lg">
                    At SpyVribe, we are dedicated to fostering connections that matter. As a fast-growing social platform, we empower individuals, brands, and communities to share stories, build relationships, and discover new ways to engage with the world. 
                </div>
                
              </motion.div>
              <motion.div
                key="front-footer-content-2"
                variants={columnVariants}
                className="col-span-12 xls:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-4 pl-0 md:pl-28 2xl:pl-36 mt-10 xls:mt-0"
              >
                  <div className="relative">
                    <div className="text-xl 2xl:text-2xl text-white capitalize mb-4 md:mb-8 font-bold">Sitemap</div>
                      {sitemenudata?.length > 0 && (
                        <div className="space-y-2">
                          {sitemenudata?.map((item, index) => {
                              return (
                                <NavLink
                                    to={item?.link}
                                    key={index}
                                    className={"flex-shrink flex-grow transition-all duration-300 text-lg tracking-wide text-white/80 block hover:text-white"}
                                  >
                                  <span>{item?.name}</span>
                                </NavLink>
                              );
                            })}      
                        </div>
                      )}
                  </div>
                  <div className="relative">
                    <div className="text-xl 2xl:text-2xl text-white capitalize mb-4 md:mb-8 font-bold">Helpful resource</div>
                      {helpmenudata?.length > 0 && (
                        <div className="space-y-2">
                          {helpmenudata?.map((item, index) => {
                              return (
                                <NavLink
                                    to={item?.link}
                                    key={index}
                                    className={"flex-shrink flex-grow transition-all duration-300 text-lg tracking-wide text-white/80 block hover:text-white"}
                                  >
                                  <span>{item?.name}</span>
                                </NavLink>
                              );
                            })}      
                        </div>
                      )}
                  </div>
                  <div className="relative">
                    <div className="text-xl 2xl:text-2xl text-white capitalize mb-4 md:mb-8 font-bold">Social media</div>
                      {socialmediadata?.length > 0 && (
                        <div className="space-y-2">
                          {socialmediadata.map((item, index) => (
                            <NavLink
                              key={item?.id || index}
                              to={item?.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center gap-2 transition-all duration-300 hover:opacity-80"
                            >
                              <div className="flex items-center justify-center w-5 h-5 rounded-md bg-white text-black text-xs">
                                <i className={`fa-brands ${item?.icon}`} />
                              </div>

                              <div className="text-lg tracking-wide text-white/80">
                                {item?.name}
                              </div>
                            </NavLink>
                          ))}
                        </div>
                      )}

                  </div>
              </motion.div>
            
            </motion.div>
            <motion.div
              key="front-footer-bar"
              variants={containerVariants}
              initial="hidden"
              whileInView="show"
              exit="hidden"
              viewport={{ once: true, amount: 0.3 }}
              className="grid grid-cols-12 py-8 border-t border-white/5"
            >
              <motion.div
                key="front-footer-copyright"
                variants={optionVariantsLeft}
                className="col-span-12 xls:col-span-4"
              >
                <div className="relative">
                      <Input
                          inputPlaceholder="Enter your email address"
                          inputClasses="text-white !text-base !px-0 !bg-transparent border-0 border-b rounded-none border-white/60 w-full !pr-12"
                        />
                      <div className="absolute right-0 top-0 bottom-1">
                            <Button
                              buttonIcon={"fa-regular fa-arrow-right"}
                              buttonClasses={"text-white text-lg bg-transparent hover:bg-white/20"}
                            />
                      </div>  
                </div>
                
              </motion.div>
              <motion.div
                key="front-footer-social"
                variants={optionVariantsRight}
                className="col-span-12 xls:col-span-8 mt-5 xls:mt-0"
              >
                  <div className="relative text-center xls:text-right text-white/60 text-base">
                      © 2026 SpyVribe. All rights reserved.
                  </div>
                
              </motion.div>
            </motion.div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FrontFooter;
